import { z } from 'zod';

import { levelMappingBucketCountsSchema } from '../../position-level-mapping';

export const levelMappingProgressBlockSchema = z.object({
    type: z.literal('level-mapping-progress'),
    blockId: z.string(),
    architectureId: z.string(),
    runId: z.string(),
    status: z.string(),
    unitsDone: z.number().int().catch(0),
    unitsTotal: z.number().int().nullish(),
    buckets: levelMappingBucketCountsSchema.nullish(),
    error: z.object({ code: z.string(), message: z.string() }).nullish(),
});

export type LevelMappingProgressBlock = z.infer<typeof levelMappingProgressBlockSchema>;
